export default __webpack_public_path__ + "static/sectorOriente-951c6c27fcb469a505cca9fc26e8c722.webp";